import { useEffect } from "react";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSEO({ title, description, keywords, image } = {}) {
  useEffect(() => {
    const canonical = new URL(window.location.pathname || "/", window.location.origin).href;

    if (title) document.title = title;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    if (title) {
      setMeta("property", "og:title", title);
      setMeta("property", "og:type", "website");
      setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
      setMeta("name", "twitter:title", title);
    }
    if (description) setMeta("name", "twitter:description", description);
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("property", "og:url", canonical);
    if (image) {
      setMeta("property", "og:image", image);
      setMeta("name", "twitter:image", image);
    }
    setLink("canonical", canonical);
  }, [title, description, keywords, image]);
}
